import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import { mucHocPhiTheoCTDTApi } from "../../../api/category/mucHocPhiTheoCTDTApi";
import { IDmMucHocPhiTheoCTDTCopyKyThuRequest } from "../../../model/request/category/dmMucHocPhiTheoCTDTCopyKyThuRequest";
import { IDmMucHocPhiTheoCTDTViewModelRequest } from "../../../model/request/category/dmMucHocPhiTheoCTDTViewModelRequest";
import { IMucHocPhiTheoCTDT } from "../../../model/respone/category/IDmMucHocPhiTheoCTDT";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eDmMucHocPhiTheoCTDTActionIds,
  IDmMucHocPhiTheoCTDTActionTypes,
} from "../../action-types/category/IDmMucHocPhiTheoCTDTActions";

const A = () => rootActions.category.mucHocPhiTheoCTDT;

export function* mucHocPhiTheoCTDTSaga(): any {
  yield takeLatest(eDmMucHocPhiTheoCTDTActionIds.LOAD_CTDTS_START, loadCtdtsWorker);
  yield takeLatest(eDmMucHocPhiTheoCTDTActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmMucHocPhiTheoCTDTActionIds.SAVE_START, saveWorker);
  yield takeLatest(eDmMucHocPhiTheoCTDTActionIds.LOCK_START, lockWorker);
  yield takeLatest(eDmMucHocPhiTheoCTDTActionIds.UNLOCK_START, unlockWorker);
  yield takeLatest(eDmMucHocPhiTheoCTDTActionIds.COPY_START, copyWorker);
}

function* reloadIfSelected(): any {
  const request = yield select((x: any) => x.category.mucHocPhiTheoCTDT.request);
  if (request?.id_dt && request?.hoc_ky && request?.nam_hoc) {
    yield put(A().LOAD_START(request));
  }
}

function* loadCtdtsWorker(action: IDmMucHocPhiTheoCTDTActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoCTDTViewModelRequest;
  const res: IBaseRespone = yield call(mucHocPhiTheoCTDTApi.SelectCTDTs, payload);
  if (res.is_success) {
    yield put(A().LOAD_CTDTS_SUCCESS(res.data));
  } else {
    yield put(A().LOAD_CTDTS_ERRR(res.message ?? "Có lỗi"));
  }
}

function* loadWorker(action: IDmMucHocPhiTheoCTDTActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoCTDTViewModelRequest;
  const res: IBaseRespone = yield call(mucHocPhiTheoCTDTApi.Select, payload);
  if (res.is_success) {
    yield put(A().LOAD_SUCCESS(res.data));
  } else {
    yield put(A().LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDmMucHocPhiTheoCTDTActionTypes): any {
  const payload = action.payload as IMucHocPhiTheoCTDT[];
  const res = yield call(mucHocPhiTheoCTDTApi.Save, payload);
  if (res) {
    if (res.is_success) {
      yield put(A().SAVE_SUCCESS(res.data));
    } else {
      yield put(A().SAVE_ERROR(res.message ?? "Có lỗi"));
    }
  }
}

function* lockWorker(action: IDmMucHocPhiTheoCTDTActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoCTDTViewModelRequest;
  const res = yield call(mucHocPhiTheoCTDTApi.Lock, payload);
  if (res) {
    if (res.is_success) {
      yield put(A().LOCK_SUCCESS(res.data));
      yield* reloadIfSelected();
    } else {
      yield put(A().LOCK_ERRR(res.message ?? "Có lỗi"));
    }
  }
}

function* unlockWorker(action: IDmMucHocPhiTheoCTDTActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoCTDTViewModelRequest;
  const res = yield call(mucHocPhiTheoCTDTApi.Unlock, payload);
  if (res) {
    if (res.is_success) {
      yield put(A().UNLOCK_SUCCESS(res.data));
      yield* reloadIfSelected();
    } else {
      yield put(A().UNLOCK_ERRR(res.message ?? "Có lỗi"));
    }
  }
}

function* copyWorker(action: IDmMucHocPhiTheoCTDTActionTypes): any {
  const payload = action.payload as IDmMucHocPhiTheoCTDTCopyKyThuRequest;
  const res = yield call(mucHocPhiTheoCTDTApi.CopyKyThu, payload);
  if (res) {
    if (res.is_success) {
      yield put(A().COPY_SUCCESS(res.data));
      yield* reloadIfSelected();
    } else {
      yield put(A().COPY_ERROR(res.message ?? "Có lỗi"));
    }
  }
}
